import { Action } from '@ngrx/store';

//eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isAction(action: any): action is Action {
  return (
    typeof action === 'object' &&
    action !== null &&
    'type' in action &&
    typeof (action as { type: unknown }).type === 'string'
  );
}
